import { render, staticRenderFns } from "./Searchbing.vue?vue&type=template&id=b5854a74&scoped=true"
import script from "./Searchbing.vue?vue&type=script&lang=js"
export * from "./Searchbing.vue?vue&type=script&lang=js"
import style0 from "./Searchbing.vue?vue&type=style&index=0&id=b5854a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5854a74",
  null
  
)

export default component.exports